import withApollo from 'nextDir/enhancers/page/withApollo';

import { JobsByCompanyNamePage } from 'src/modules/Seo/JobsByCompanyNamePage';

export default withApollo(JobsByCompanyNamePage);
